import Input from './input';

function valueFormat() {
  return {
    inheritAttrs: false,
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      parser: {
        type: [Array, Function, Object],
      },
      formatter: {
        type: [Array, Function, Object],
      },
      value: { validator() {
        return true;
      } },
      isChanged: {
        type: Function,
        default: (a, b) => a !== b,
      },
    },
    data() {
      return {
        dataValue: undefined,
      };
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          this.dataValue = this.handler('formatter', value);
        },
      },
    },
    methods: {
      handler(type, value, isInputing) {
        if (!(value != null)) return; // eslint-disable-line

        let handler = this[type];

        if (!Array.isArray(handler)) {
          handler = [handler];
        }

        handler.forEach((rule) => {
          if (typeof rule === 'function' && !isInputing) {
            value = rule(value);
          } else if (rule.handler && (!isInputing || rule.input)) {
            value = rule.handler(value);
          }
        });

        return value;
      },
      transform(value, isInputing) {
        const propValue = this.handler('parser', value, isInputing);
        const inputValue = this.handler('formatter', propValue, isInputing);
        return { propValue, inputValue };
      },
      onChange() {
        const { inputValue, propValue } = this.transform(this.dataValue);
        if (this.isChanged(propValue, this.value)) {
          this.$emit('change', propValue);
        } else if (this.dataValue !== inputValue) {
          this.dataValue = inputValue;
        }
      },
      onInput(value) {
        const { inputValue } = this.transform(value, true);
        this.dataValue = inputValue;
        this.$emit('input', this.dataValue);
      },
    },
    render(h) {
      const {
        input,
        change,

        ...othersEvent
      } = this.$listeners;

      return h(Input, {
        on: {
          input: this.onInput,
          change: this.onChange,
          ...othersEvent,
        },

        props: {
          ...this.$attrs,
          value: this.dataValue,
        },

        scopedSlots: {
          ...this.$scopedSlots,
        },

        ref: 'refInputElm',
      });
    },
  };
}

export default valueFormat;
